import { OptimizelyLongString, OptimizelyXhtmlString } from "..";
import { OptimizelyBlockExpandedValue } from "../expanded";
import { TitleBlockStyle } from "../unions";

interface TitleBlockStyleProperty extends OptimizelyLongString {
    value: TitleBlockStyle;
}

export interface TitleBLockData extends OptimizelyBlockExpandedValue {
    type: ['Block', 'TitleBlock'];
    title: OptimizelyLongString;
    text: OptimizelyXhtmlString;
    style: TitleBlockStyleProperty;
};

export const isTitleBlock = (block: OptimizelyBlockExpandedValue): block is TitleBLockData => {
    return block.contentType[1] === 'TitleBlock';
}